export default {
  brandId: '',
  brandName: '',
  class: '',
  subclass: '',
  color: '',
  shortColor: '',
  size: '',
  styleId: '',
  division: '',
  retailPrice: '0.00',
  itemPriceEach: '0.00',
  itemPriceTotal: '0.00',
  itemTaxEach: '0.00',
  originalPrice: '0.00',
  departmentCode: '',
  currencyCode: 'USD',
  freightEach: '0.00',
  otherEach: '0.00',
  adjustedPriceEach: '0.00',
  productName: '',
  productImageUrl: '',
  designerName: '',
  quantity: 1,
  pimSku: '',
  isIce: false,
  isGiftWrap: false,
  colorId: '',
  sizeId: '',
  promotionCodes: [],
  upc: '',
  overriddenPrice: '',
  emplDiscRate: '',
  maxDiscPct: '',
  supplier: '',
};
